{
  "containerViewFilters": [
    {
      "name": "containerNo",
      "displayLabel": "Container No",
      "dataType": "STRING",
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "CONTAINER_NO_EQUALS"
      }
    },
    {
      "name": "igmItemNo",
      "displayLabel": "IGM Item No",
      "dataType": "STRING",
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "IGM_ITEM_NO_EQUALS"
      }
    },
    {
      "name": "blNo",
      "displayLabel": "BL No",
      "dataType": "STRING",
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "BL_NO_EQUALS"
      }
    },
    {
      "name": "accountHolder",
      "displayLabel": "Account Holder",
      "dataType": "STRING",
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "ACCOUNT_HOLDER_EQUALS"
      },
      "hasLookup": true,
      "searchConfig": {
        "apiUrl": "v1/customers/list",
        "selectFields": ["id", "name", "code"],
        "filterByKeys": ["name", "code"],
        "limit": 10,
        "orderBy": { "name": "asc" },
        "bindLabel": "name",
        "bindValue": "id",
        "displayColumns": [{ "key": "name", "header": "Name" }]
      }
    },
    {
      "name": "vesselId",
      "displayLabel": "Vessel",
      "dataType": "STRING",
      "hasLookup": true,
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "VESSEL_EQUALS"
      },
      "searchConfig": {
        "apiUrl": "v1/vessel-port-train-details/list",
        "selectFields": ["id", "vesselName", "viaNo"],
        "filterByKeys": ["vesselName"],
        "limit": 10,
        "orderBy": { "vesselName": "asc" },
        "bindLabel": "vesselName",
        "bindValue": "id",
        "displayColumns": [{ "key": "vesselName", "header": "Vessel Name" }],
        "additionalFilters": {
          "name": "active",
          "alias": "active",
          "operator": "EQ",
          "value": ["true"]
        }
      }
    }
  ],

  "containerTableConfig": {
    "columns": [
      {
        "fieldName": "containerNo",
        "displayName": "Container No",
        "dataType": "STRING"
      },
      {
        "fieldName": "containerSize",
        "displayName": "Size",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "50px"
        },
        "styleConfig": {
          "type": "badge",
          "styleProperties": {
            "width": "40px",
            "border-radius": "6px",
            "padding": "2px 8px",
            "align-items": "center",
            "display": "flex",
            "font-family": "Inter",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "500",
            "line-height": "18px",
            "text-align": "center"
          },
          "conditions": [
            {
              "expression": "eq(value, '20')",
              "styleProperties": {
                "border": "1px solid var(--Blue-200, #B2DDFF)",
                "background": "var(--Blue-50, #EFF8FF)",
                "color": "var(--Blue-700, #175CD3)"
              }
            },
            {
              "expression": "eq(value, '40')",
              "styleProperties": {
                "border": "1px solid var(--Purple-200, #D9D6FE)",
                "background": "var(--Purple-50, #F4F3FF)",
                "color": "var(--Purple-700, #5925DC)"
              }
            },
            {
              "expression": "eq(value, '45')",
              "styleProperties": {
                "border": "1px solid var(--Pink-200, #FCCEEE)",
                "background": "var(--Pink-50, #FDF2FA)",
                "color": "var(--Pink-700, #C11574)"
              }
            }
          ]
        }
      },

      {
        "fieldName": "containerType",
        "displayName": "Type",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "50px"
        },
        "styleConfig": {
          "type": "badge",
          "styleProperties": {
            "width": "36px",
            "border-radius": "6px",
            "padding": "2px 8px",
            "align-items": "center",
            "display": "flex",
            "font-family": "Inter",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "500",
            "line-height": "18px",
            "text-align": "center",
            "background": "var(--Gray-100, #F2F4F7)",
            "box-shadow": " 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
          }
        }
      },
      {
        "fieldName": "vesselName",
        "displayName": "Vessel",
        "dataType": "STRING"
      },
      {
        "fieldName": "viaNo",
        "displayName": "Via No",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "50px"
        }
      },
      {
        "fieldName": "shippingLineName",
        "displayName": "Shipping Line",
        "dataType": "STRING"
      },
      {
        "fieldName": "accountHolderName",
        "displayName": "Account Holder",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "300px"
        }
      },
      {
        "fieldName": "importType",
        "displayName": "Import Type",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "80px"
        }
      },

      {
        "fieldName": "hazardous",
        "displayName": "Hazardous",
        "dataType": "BOOLEAN",
        "thStyleConfig": {
          "width": "80px"
        },
        "styleConfig": {
          "type": "badge",
          "styleProperties": {
            "width": "55px",
            "border-radius": "16px",
            "padding": "2px 8px",
            "align-items": "center",
            "display": "flex",
            "font-family": "Inter",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "500",
            "line-height": "18px",
            "text-align": "center"
          },
          "conditions": [
            {
              "expression": "eq(value, 'true')",
              "icon": "assets/icons/frame_icon.svg",
              "iconPosition": "left",
              "styleProperties": {

                "border": "1px solid var(--Error-200, #FECDCA)",
                "background": "var(--Error-50, #FEF3F2)",
                "color": "var(--Error-700, #B42318)"
              },
              "iconStyleProperties": {
                "width": "16px",
                "height": "16px",
                "background": "#D92D20"
              }
            },
            {
              "expression": "eq(value, 'false')",
              "styleProperties": {
                "width": "40px",
                "border": "1px solid var(--Gray-200, #E4E7EC)",
                "background": "var(--Gray-50, #F9FAFB)",
                "color": "var(--Gray-700, #344054)"
              }
            }
          ]
        }
      },
      {
        "fieldName": "odc",
        "displayName": "ODC",
        "dataType": "BOOLEAN",
        "thStyleConfig": {
          "width": "80px"
        },
        "styleConfig": {
          "type": "badge",
          "styleProperties": {
            "width": "40px",
            "border-radius": "16px",
            "padding": "2px 8px",
            "align-items": "center",
            "display": "flex",
            "font-family": "Inter",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "500",
            "line-height": "18px",
            "text-align": "center"
          },
          "conditions": [
            {
              "expression": "eq(value, 'true')",
              "styleProperties": {
                "border": "1px solid var(--Success-200, #ABEFC6)",
                "background": "var(--Success-50, #ECFDF3)",
                "color": "var(--Success-700, #067647)"
              }
            },
            {
              "expression": "eq(value, 'false')",
              "styleProperties": {
                "border": "1px solid var(--Gray-200, #E4E7EC)",
                "background": "var(--Gray-50, #F9FAFB)",
                "color": "var(--Gray-700, #344054)"
              }
            }
          ]
        }
      },

      {
        "fieldName": "isReeferPluggedIn",
        "displayName": "Refer Plugin",
        "dataType": "BOOLEAN",
        "thStyleConfig": {
          "width": "80px"
        },
        "styleConfig": {
          "type": "badge",
          "styleProperties": {
            "width": "40px",
            "border-radius": "16px",
            "padding": "2px 8px",
            "align-items": "center",
            "display": "flex",
            "font-family": "Inter",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "500",
            "line-height": "18px",
            "text-align": "center"
          },
          "conditions": [
            {
              "expression": "eq(value, 'true')",
              "styleProperties": {
                "border": "1px solid var(--Success-200, #ABEFC6)",
                "background": "var(--Success-50, #ECFDF3)",
                "color": "var(--Success-700, #067647)"
              }
            },
            {
              "expression": "eq(value, 'false')",
              "styleProperties": {
                "border": "1px solid var(--Gray-200, #E4E7EC)",
                "background": "var(--Gray-50, #F9FAFB)",
                "color": "var(--Gray-700, #344054)"
              }
            }
          ]
        }
      },
      {
        "fieldName": "totalPackages",
        "displayName": "NOP",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "80px"
        }
      },
      {
        "fieldName": "cargoWeight",
        "displayName": "Cargo Weight",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "80px"
        }
      },
      {
        "fieldName": "scanType",
        "displayName": "Scan Type",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "80px"
        },
        "styleConfig": {
          "type": "badge",
          "styleProperties": {
            "width": "36px",
            "border-radius": "6px",
            "padding": "2px 8px",
            "align-items": "center",
            "display": "flex",
            "font-family": "Inter",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "500",
            "line-height": "18px",
            "text-align": "center",
            "background": "var(--Gray-100, #F2F4F7)",
            "box-shadow": " 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
          }
        }
      },
      {
        "fieldName": "modifiedBy",
        "dbName": "modified_by",
        "displayName": "Modified By",
        "dataType": "STRING",
        "styleConfig": {
          "type": "user-avatar"
        }
      },
      {
        "fieldName": "modifiedDate",
        "dbName": "modified_date",
        "displayName": "Modified Date",
        "dataType": "DATETIME",
        "sortable": true
      }
    ]
  },

  "itemTableConfig": {
    "columns": [
      {
        "fieldName": "igmNo",
        "displayName": "IGM No",
        "dataType": "STRING"
      },
      {
        "fieldName": "itemNo",
        "displayName": "Item No",
        "dataType": "STRING"
      },
      {
        "fieldName": "subItemNo",
        "displayName": "Sub Item No",
        "dataType": "STRING"
      },
      {
        "fieldName": "blNo",
        "displayName": "MBL No",
        "dataType": "STRING"
      },
      {
        "fieldName": "hblNo",
        "displayName": "HBL No",
        "dataType": "STRING"
      },
      {
        "fieldName": "importType",
        "displayName": "Import Type",
        "dataType": "STRING"
      },
      {
        "fieldName": "dpd",
        "displayName": "DPD",
        "dataType": "BOOLEAN"
      },
      {
        "fieldName": "numberOfPackages",
        "displayName": "NOP",
        "dataType": "STRING"
      },
      {
        "fieldName": "grossWeight",
        "displayName": "Gross Weight",
        "dataType": "STRING"
      }
    ]
  }
}
